/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import MedicalTermsModel from '../../models/MedicalTermsModel';

const MedliSearchTerm = (props) => {
  const term = new MedicalTermsModel(props.term);
  return (
    <span className={props.className} style={props.style}>
      {term.name()}
    </span>
  );
};
MedliSearchTerm.propTypes = {
  term: PropTypes.object,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default MedliSearchTerm;
